class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.section;

    this.sectionRoot = document.querySelector(`.pg-${sectionId}`);

    this.mainForm = this.sectionRoot
      ? this.sectionRoot.querySelector('[data-pg-cart-form]')
      : null;

    this.mainButton = this.mainForm
      ? this.mainForm.querySelector('.pg-add-cart')
      : null;

    this.mainPrice = this.sectionRoot
      ? this.sectionRoot.querySelector('.pg-price-row')
      : null;

    this.button = this.querySelector('[data-sticky-atc-submit]');
    this.buttonText = this.querySelector('[data-sticky-atc-button-text]');
    this.priceEl = this.querySelector('[data-sticky-atc-price]');
    this.closeButton = this.querySelector('[data-sticky-atc-close]');

    /* Add To Cart */
    if (this.button) {
      this.button.addEventListener(
        'click',
        this.handleClick.bind(this)
      );
    }

    /* Close Button */
    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.handleClose.bind(this)
      );
    }

    /* Main Product Button */
    if (this.mainButton) {
      this.setupVisibilityObserver();
      this.setupButtonObserver();
    }

    /* Product Price */
    if (this.mainPrice) {
      this.setupPriceObserver();
    }
  }

  setupVisibilityObserver() {
    this.visibilityObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];

      const scrolledPast =
        !entry.isIntersecting &&
        entry.boundingClientRect.top < 0;

      /*
       * Show sticky ATC when main Add To Cart
       * button is above the viewport.
       */
      if (scrolledPast) {
        this.classList.add('sticky-atc--visible');
      } else {
        this.classList.remove('sticky-atc--visible');

        /* Reset close state */
        this.dataset.closed = 'false';
      }
    }, {
      threshold: 0
    });

    this.visibilityObserver.observe(this.mainButton);
  }

  setupButtonObserver() {
    this.syncButtonState();

    this.buttonObserver = new MutationObserver(
      this.syncButtonState.bind(this)
    );

    this.buttonObserver.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
  }

  syncButtonState() {
    if (!this.button || !this.mainButton) return;

    this.button.disabled = this.mainButton.disabled;

    if (this.buttonText) {
      this.buttonText.textContent = this.mainButton.disabled
        ? 'Sold out'
        : 'Add to cart';
    }
  }

  setupPriceObserver() {
    this.syncPrice();

    this.priceObserver = new MutationObserver(
      this.syncPrice.bind(this)
    );

    this.priceObserver.observe(this.mainPrice, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  syncPrice() {
    if (!this.priceEl || !this.mainPrice) return;

    this.priceEl.innerHTML = this.mainPrice.innerHTML;
  }

  handleClick() {
    if (this.mainButton) {
      this.mainButton.click();
    }
  }

  handleClose() {
    /*
     * Hide sticky ATC
     */
    this.classList.remove('sticky-atc--visible');

    /*
     * Remember that user closed it
     */
    this.dataset.closed = 'true';
  }

  disconnectedCallback() {
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
    }

    if (this.buttonObserver) {
      this.buttonObserver.disconnect();
    }

    if (this.priceObserver) {
      this.priceObserver.disconnect();
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    StickyAddToCart
  );
}